import { render } from "./SelectBundle.vue?vue&type=template&id=375d3788&ts=true"
import script from "./SelectBundle.vue?vue&type=script&lang=ts"
export * from "./SelectBundle.vue?vue&type=script&lang=ts"

import "./SelectBundle.vue?vue&type=style&index=0&id=375d3788&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__